import { render } from "./UpdateSectionOrder.vue?vue&type=template&id=45729a8b"
import script from "./UpdateSectionOrder.vue?vue&type=script&lang=js"
export * from "./UpdateSectionOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__